import ScrollMagic from 'scrollmagic'
import * as Util from '../util/utilities'

export function hero() {
    const scrollcontrol = new ScrollMagic.Controller()

    if ($('[data-split-hero]').length) {
        const hero = new TimelineMax()

        // :---- Top
        const topSlice = $('[data-hero-slice-t]')
        const topContent = $('[data-hero-content-t]')
        const topAsset = $('[data-hero-asset-t]')
        const topOverlay = $('[data-hero-overlay-t]')
        const topCover = $('[data-hero-cover-t]')

        // :---- Bottom
        const bottomSlice = $('[data-hero-slice-b]')
        const bottomContent = $('[data-hero-content-b]')
        const bottomAsset = $('[data-hero-asset-b]')
        const bottomOverlay = $('[data-hero-overlay-b]')
        const bottomCover = $('[data-hero-cover-b]')

        hero.set(topSlice, { top: '-100%', opacity: 1 })
            .set(bottomSlice, { bottom: '-100%', opacity: 1 })
            .to(topSlice, 0.48, {
                top: '-20%',
                delay: 0.8,
                ease: Circ.easeInOut,
            })
            .to(bottomSlice, 0.48, {
                bottom: '-20%',
                delay: -0.32,
                ease: Circ.easeInOut,
            })
            .set(topContent, { top: '25%', skewY: '6deg' })
            .set(bottomContent, { bottom: '25%', skewY: '6deg' })
            .to(topSlice, 0.64, { skewY: '-6deg' })
            .to(bottomSlice, 0.64, { skewY: '-6deg', delay: -0.64 })

            .set(topOverlay, { opacity: 1 })
            .set(topAsset, { opacity: 1 })
            .set(bottomOverlay, { opacity: 1 })
            .set(bottomAsset, { opacity: 1 })

            .to(topCover, 0.4, { opacity: 0 })
            .to(bottomCover, 0.4, { opacity: 0, delay: -0.4 })

        /* :: Parallax
        ---------------------------------- */
        Util.addAnimations(
            [
                TweenMax.fromTo(
                    $('[data-split-hero]').find('[data-hero-content]'),
                    2,
                    {
                        y: '0',
                    },
                    {
                        y: '-80%',
                        ease: Linear.easeNone,
                    },
                ),
                TweenMax.fromTo(
                    $('[data-split-hero]').find(topAsset),
                    2,
                    {
                        y: '0',
                    },
                    {
                        y: '48%',
                        ease: Linear.easeNone,
                    },
                ),
                TweenMax.fromTo(
                    $('[data-split-hero]').find(bottomAsset),
                    2,
                    {
                        y: '0',
                    },
                    {
                        y: '32%',
                        ease: Linear.easeNone,
                    },
                ),
            ],
            '[data-split-hero]',
            'onLeave',
            0,
            '130%',
            scrollcontrol,
        )
    } else if ($('[data-hero]').length) {
        const hero = $('[data-hero]')
        const content = hero.find('[data-hero-content]')
        const background = hero.find('[data-hero-asset]')

        /* :: Parallax
        ---------------------------------- */
        Util.addAnimations(
            [
                TweenMax.fromTo(
                    content,
                    2,
                    {
                        y: '0',
                    },
                    {
                        y: '-80%',
                        ease: Linear.easeNone,
                    },
                ),
                TweenMax.fromTo(
                    background,
                    2,
                    {
                        y: '0',
                    },
                    {
                        y: '48%',
                        ease: Linear.easeNone,
                    },
                ),
            ],
            '[data-hero]',
            'onLeave',
            0,
            '130%',
            scrollcontrol,
        )
    }
}
